// VisionMissionValuesBanner.jsx 

import { useTranslation } from 'react-i18next';
import AVIcon from '../icons/AllVoicedIcons';

const VisionMissionValuesBanner = () => {
  const { t } = useTranslation();

  return (
    <section className="vmv-banner">
      <div className="vmv-content">
        <h2 className="vmv-title">
          {t('vision_mission_values.title', 'Vision, Mission & Values')}
        </h2>

        <p className="vmv-subtitle">
          {t(
            'vision_mission_values.subtitle',
            'The heart of All-Voiced: why we exist, what drives us, and the principles that shape our growing ecosystem for auditory-perceptual voice assessment.'
          )}
        </p>

        <div className="vmv-grid">
          <div className="vmv-card">
            <AVIcon icon="eye" size={42} color="#209385" />
            <h3>{t('vision_mission_values.vision_title', 'Our Vision')}</h3>
            <p>
              {t(
                'vision_mission_values.vision_text',
                'To make auditory-perceptual voice evaluation more structured, comparable, and reusable across education, research, clinical practice, and voice technology.'
              )}
            </p>
          </div>

          <div className="vmv-card">
            <AVIcon icon="target" size={42} color="#209385" />
            <h3>{t('vision_mission_values.mission_title', 'Our Mission')}</h3>
            <p>
              {t(
                'vision_mission_values.mission_text',
                'To train expert listeners and provide digital infrastructure that turns human perception into structured data for learning, research, and better voice assessment.'
              )}
            </p>
          </div>

          <div className="vmv-card">
            <AVIcon icon="heart1" size={42} color="#209385" />
            <h3>{t('vision_mission_values.values_title', 'Our Values')}</h3>
            <p>
              {t(
                'vision_mission_values.values_text',
                'We believe in scientific rigor, human expertise, openness, and care — and in the power of listening to generate knowledge across languages, cultures, and contexts.'
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionValuesBanner;
